$('.image-carousel .items').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  adaptiveHeight: true,
  prevArrow: `<button type="button" class="slick-prev"><span class="visually-hidden">Previous</span>${window.iconStrings.previousControl}</button>`,
  nextArrow: `<button type="button" class="slick-next"><span class="visually-hidden">Next</span>${window.iconStrings.nextControl}</button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        dots: true,
        arrows: false,
        fade: false
      }
    }
  ]
});